export default __webpack_public_path__ + "static/earthtones-c9ad08de789c4a5e4aeca8e6e56555e9.svg";